import script from "./BookingImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingImage.vue?vue&type=script&setup=true&lang=ts"

import "./BookingImage.vue?vue&type=style&index=0&id=2e711ede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e711ede"]])

export default __exports__